var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.hiddenHeaderRoute.includes(_vm.$route.name))?_c('Header'):_c('Header2'),_c('router-view'),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hiddenfooter.includes(_vm.$route.name)),expression:"!hiddenfooter.includes($route.name)"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }